import { urlConstruirJsons, urlGenerarExcel, urlInsertJsons, urlObtenerDetallesLogSerial, urlObtenerLogsSerials, urlSubirExceles, urlTransformToCsv, urlUpdateSeries } from "utilities/endpoints";

export async function subirExceles(data, token) {
 try {
         const params = {
             method: 'POST',
             headers: {
                 'X-Requested-With': 'XMLHttpRequest',
                 'Authorization': token
             },
             body: data
         }
         const response = await fetch(urlSubirExceles, params);
         const result = await response.json();
 
         if (response.status !== 200) throw result
 
         return result;
     } catch (error) {
         return error
     }   
}

export async function transformToCsv(token) {
    try {
            const params = {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': token
                },
            }
            const response = await fetch(urlTransformToCsv, params);
            const result = await response.json();
    
            if (response.status !== 200) throw result
    
            return result;
        } catch (error) {
            return error
        }   
}


export const buildJsons =  async(token, IdUser)=>{
    try {
            const params = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': token
                },
                body: JSON.stringify({
                    userId:IdUser
                })
            }
            const response = await fetch(urlConstruirJsons, params);
            const result = await response.json();
    
            if (response.status !== 200) throw result
    
            return result;
        } catch (error) {
            return error
        }   
}

export const obtenerLogsSerials = async(token)=>{
    try {
        const params = {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': token
            },
            method: 'GET',
        }
        const response = await fetch(urlObtenerLogsSerials, params);
        const result = await response.json();

        if (response.status !== 200) throw result

        return result;
    } catch (error) {
        return error
    }
}

export const insertJsons =  async(token, id, folder)=>{
    try {
            const params = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': token
                },
                body: JSON.stringify({
                    id,
                    folder
                })
            }
            const response = await fetch(urlInsertJsons, params);
            const result = await response.json();
    
            if (response.status !== 200) throw result
    
            return result;
        } catch (error) {
            return error
        }   
}

export const obtenerDetallesLog = async(token, id)=>{
    try {
        const params = {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': token
            },
            method: 'GET',
        }
        const response = await fetch(`${urlObtenerDetallesLogSerial}/${id}`, params);
        const result = await response.json();

        if (response.status !== 200) throw result

        return result;
    } catch (error) {
        return error
    }
}


export const generarExcel = async(token, nombreArchivo, nombre, id)=>{
    try {
        const params = {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': token
            },
            body: JSON.stringify({
                nombreArchivo,
                nombre,
                id
            })
        }
        const response = await fetch(urlGenerarExcel, params);
    
        if (response.status !== 200) throw response
    
        return response;
        
    } catch (error) {
        return error
    }
}

export const actualizarSerie = async (token, data)=>{
    try {
        const params = {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': token
            },
            body: data
        }
        const response = await fetch(urlUpdateSeries, params);
        const result = await response.json();
 
        if (response.status !== 200) throw result
 
        return result;
    } catch (error) {
        return error
    }   
}


export const actualizarSerieFilterJson = async (token, data)=>{
    try {
        const params = {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': token
            },
            body: data
        }
        const response = await fetch(`${urlUpdateSeries}/filter-json`, params);
        const result = await response.json();
 
        if (response.status !== 200) throw result
 
        return result;
    } catch (error) {
        return error
    }   
}